<template inject>
	<th class="slds-cell-edit">
		<template v-if="filterable">
			<div class="slds-form-element slds-grid slds-wrap">
				<label class="slds-form-element__label slds-form-element__label_edit slds-no-flex" :for="`${colKey}-f`">
					<span class="slds-assistive-text">{{ colName }}</span>
				</label>
				<div class="slds-form-element__control slds-grow">
					<input class="slds-input" :id="`${colKey}-f`" type="text" value="" v-model="filterValue" @change="filterCol(`${colKey}`, `${colType}`)">
				</div>
			</div>
		</template>
	</th>
</template>
<script>
export default {
	name: 'TableHeadCellFilter',
	props: {
		colName: {
			type: String,
			default: '',
		},
		colKey: {
			type: String,
			default: ''
		},
		colType: {
			type: String,
			default: ''
		},
		filterable: {
			type: Boolean,
			default: true
		}
	},
	data() {
		return {
			filterValue: ''
		}
	},
	methods: {
		filterCol: function(col, type) {
			let value, operator;
			switch(type) {
				case 'number': 
					value = this.filterValue != '' ? parseFloat(this.filterValue.replace(/[^0-9.]+/g, '')) : '';
					operator = this.filterValue.replace(/[0-9.,%]+/g, '').trim();
					break;
				case 'date': 
					value = this.filterValue != '' ? Date.parse(this.filterValue.replace(/[^0-9/]+/g, '')) : '';
					operator = this.filterValue.replace(/[0-9/]+/g, '').trim();
					break;
				default:
					value = this.filterValue;
			}

			//Replace any unknown operator with equals operator
			if(operator && !['>', '>=', '=>', '<', '<=', '=<', '='].includes(operator)){
				operator = '=';
			}

			this.$parent.filterTableCol(col, type, operator, value);
		}
	}
}
</script>